import React, { useState } from "react";
import { FiEdit3 } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import styles from "../../styles/AccountBilling/ManageTeam.module.css"; // Adjust path as needed

const initialTeam = [
    { id: 1, name: "Member 1", email: "me@email.com", role: "Owner", brand: "Brand 1", createdOn: "dd/mm/yyyy" },
    { id: 2, name: "Member 2", email: "me@email.com", role: "Employee", brand: "Brand 1", createdOn: "dd/mm/yyyy" },
    { id: 3, name: "Member 3", email: "me@email.com", role: "Employee", brand: "Brand 1", createdOn: "dd/mm/yyyy" },
    { id: 4, name: "Member 4", email: "me@email.com", role: "Employee", brand: "Brand 1", createdOn: "dd/mm/yyyy" },
    { id: 5, name: "Member 5", email: "me@email.com", role: "Employee", brand: "Brand 1", createdOn: "dd/mm/yyyy" }
];

const ManageTeam = () => {
    const [team, setTeam] = useState(initialTeam);
    const [editId, setEditId] = useState(null);
    const [editedRow, setEditedRow] = useState({});

    const handleEditClick = (member) => {
        setEditId(member.id);
        setEditedRow(member);
    };

    const handleSaveClick = (id) => {
        setTeam((prev) => prev.map((member) => (member.id === id ? { ...editedRow, id } : member)));
        setEditId(null);
    };

    const handleDelete = (id) => {
        setTeam((prev) => prev.filter((member) => member.id !== id));
    };

    const handleChange = (e) => {
        setEditedRow({ ...editedRow, [e.target.name]: e.target.value });
    };

    return (
        <div class="company-management-card">
            <div className={styles.detailsHeader}>
                <span className={styles.detailsHeading}>Manage Team</span>
            </div>
            <div className="separator" />

            <div className={styles.tableContainer}>
                <table className={styles.teamTable}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Team role</th>
                            <th>Brands</th>
                            <th>Created on</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {team.map((member) => (
                            <tr key={member.id}>
                                {editId === member.id ? (
                                    <>
                                        <td><input type="text" name="name" value={editedRow.name} onChange={handleChange} /></td>
                                        <td><input type="email" name="email" value={editedRow.email} onChange={handleChange} /></td>
                                        <td><input type="text" name="role" value={editedRow.role} onChange={handleChange} /></td>
                                        <td><input type="text" name="brand" value={editedRow.brand} onChange={handleChange} /></td>
                                        <td>{member.createdOn}</td>
                                        <td  className={styles.actions}>
                                            <button className={styles.saveBtn} onClick={() => handleSaveClick(member.id)}>Save</button>
                                            <button style={{}} className={styles.deleteBtn} onClick={() => handleDelete(member.id)}>
                                                <MdDelete /> Delete
                                            </button>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td><strong>{member.name}</strong></td>
                                        <td>{member.email}</td>
                                        <td>{member.role}</td>
                                        <td>{member.brand}</td>
                                        <td>{member.createdOn}</td>
                                        <td className={styles.actions}>
                                            <button className={styles.editBtn} onClick={() => handleEditClick(member)}>
                                                <FiEdit3 /> Edit
                                            </button>
                                            <button className={styles.deleteBtn} onClick={() => handleDelete(member.id)}>
                                                <MdDelete /> Delete
                                            </button>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button className={styles.addMemberBtn}>+ Add new member</button>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </div>
        </div>
    );
};

export default ManageTeam;
